import React, { useState } from 'react';
import PropTypes from 'prop-types';

const EmailInput = function EmailInput(props) {
    const {
        placeholder,
        children,
        validation,
        invalidclass,
    } = props;

    const input = React.Children.toArray(children).find((c) => c.type === 'input');
    const [value, setValue] = useState(input.props.defaultValue);

    const newInput = React.cloneElement(
        input,
        {
            placeholder,
            onChange: (event) => {
                const newValue = event.target.value;
                const error = !newValue.includes('@') || !newValue.includes('.')
                    ? 'Please provide a valid Email'
                    : '';

                setValue(newValue);

                if (validation) {
                    validation(event, error);
                }
            },
            value,
            defaultValue: undefined,
            className: `${input.props.className} ${invalidclass}`,
            'data-testid': `${input.props.name}-input`,
        },
    );

    return newInput;
};

EmailInput.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    placeholder: PropTypes.string,
    invalidclass: PropTypes.string,
};

EmailInput.defaultProps = {
    validation: () => { },
    placeholder: '',
    invalidclass: '',
};

export default EmailInput;
